<template>
  <div class="StockInfoList pt2 pb7 pl1 pr1" v-title data-title="库虾价格">
    <div v-if="records.length < 1" class="fc-less pt10 pb10">
      暂未查询到{{queryDateString||''}}{{queryDateString?'日':''}}库虾价格数据
    </div>
    <div v-for="item in records" :key="item.id">
      <div class="table-box">
        <div class="stock-title">
          <div class="font-bold fs8">{{item.companyName}}</div>
          <div class="fs5 pl3 pr3">{{item.companyAddress}}</div>
        </div>
        <div class="row align-items-strech stock-head">
          <div class="col-6 stock-border">行话</div>
          <div class="col-6 stock-border">{{queryDateString||''}}<div class="fs1">(元/斤)</div></div>
          <div class="col-6 stock-border">环比昨天<div class="fs1">(元/斤)</div></div>
          <div class="col-6 stock-border">同比去年<div class="fs1">(元/斤)</div></div>
        </div>
        <div v-for="qt in item.detail" :key="qt.id"
          class="row align-items-strech stock-item">
          <div class="col-6 stock-border">{{qt.jargonName}}</div>
          <div class="col-6 stock-border">{{qt.stockPrice}}</div>
          <div class="col-6 stock-border">
            <span class="fc-suppl" v-if="qt.compareWithYesterday==0">
              平
            </span>
            <div class="row align-items-center justify-content-center" v-else-if="qt.compareWithYesterday > 0">
              <span class="price-status bc-red">涨</span>
              <span class="pl1 fc-red">{{qt.compareWithYesterday}}</span>
            </div>
            <div class="row align-items-center justify-content-center" v-else-if="qt.compareWithYesterday < 0">
              <span class="price-status bc-blue">跌</span>
              <span class="pl1 fc-blue">{{Math.abs(qt.compareWithYesterday)}}</span>
            </div>
            <span class="fc-suppl" v-else>
              -
            </span>
          </div>
          <div class="col-6 stock-border">
            <span class="fc-suppl" v-if="qt.compareWithLastYear==0">
              平
            </span>
            <div class="row align-items-center justify-content-center" v-else-if="qt.compareWithLastYear > 0">
              <span class="price-status bc-red">涨</span>
              <span class="pl1 fc-red">{{qt.compareWithLastYear}}</span>
            </div>
            <div class="row align-items-center justify-content-center" v-else-if="qt.compareWithLastYear < 0">
              <span class="price-status bc-blue">跌</span>
              <span class="pl1 fc-blue">{{Math.abs(qt.compareWithLastYear)}}</span>
            </div>
            <span class="fc-suppl" v-else>
              -
            </span>
          </div>

        </div>
        <div class="pl7 pr7 text-left fs2 fc-primary pt3">备注：{{item.remark}}</div>
        <div class="pl7 pr7 text-left fs2 fc-primary pb3 pt1">发布时间：{{item.publishDate}}</div>
      </div>
      <div class="stock-phone row justify-content-center align-items-center">
        <van-icon name="phone" size="16" />
        <div v-for="(mo, moindex) in item.concatInfo"
          :key="mo.mobile"
        >
          <template v-if="moindex!==0">/</template>
          <span class="pl1">{{mo.name}}</span>
          <a class="pl1 pr1 fc-white"
          :href="'tel:'+(mo.mobile || '')">{{mo.mobile || ''}}</a>
        </div>
      </div>
    </div>
    <!-- <div @click="refresh" class="refresh bc-primary fs1">
      刷新
    </div> -->
    <a href="#quotationtop" @click="showCate" class="refresh backtop fs1">
      行话<br>解释
    </a>
    <van-popup
      v-model="cateShow"
      position="bottom"
      style="border-top-left-radius: 6px;border-top-right-radius: 6px;"
    >
      <div class="padding5 text-left">
        <div class="font-bold pb5 text-center fs8">行话解释</div>
        <div class="cate-popup">
          <template v-for="(sc, scIndex) in stockCategory">
            <div class="font-bold fc-dark pt5 fs6" :key="sc.id">
              {{scIndex+1}}. {{sc.name}}
            </div>
            <div :key="sc.id+'s'" class="pt1 pl7 fs4 fc-less">{{sc.describe}}</div>
          </template>
        </div>
      </div>
      <div class="text-center pt1 pb10">
        <van-button @click="cateShow = false;" class="btn-common" type="info" plain style="">关 闭</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { sendRequest, getStockInfoList, getStockCategoryOptions } from '../../network/NetworkAccessor';

export default Vue.extend({
  name: 'StockInfoList',
  components: {},
  data() {
    return {
      loading: false,
      records: [],
      queryDate: '',
      size: 20,
      cateShow: false,
      stockCategory: [],
    };
  },
  props: {
    queryDateProp: {
      type: String,
      default: '',
    },
  },
  computed: {
    queryDateString() {
      if (this.queryDate) {
        const list = this.queryDate.split('');
        const month = `${list[list.length - 4] === '0' ? '' : list[list.length - 4] || ''}${list[list.length - 3] || ''}`;
        const day = `${list[list.length - 2] === '0' ? '' : list[list.length - 2] || ''}${list[list.length - 1] || ''}`;
        return `${month}月${day || ''}`;
      }
      return '';
    },
  },
  methods: {
    getStockInfoList(page = 1) {
      const queryDate = this.queryDateProp;
      sendRequest(getStockInfoList, {
        current: page,
        size: this.size,
        queryDate,
        // userId,
      }).then((res) => {
        const {
          total = 1, records = [], pages = 1, hasNext = false,
        } = res;
        const rds = records.map(rd => Object.assign({}, rd, {
          concatInfo: JSON.parse(rd.concatInfo || null),
        }));
        // eslint-disable-next-line eqeqeq
        if (page == 1) {
          this.records = rds;
        } else {
          this.records = this.records.concat(rds);
        }
        this.total = total;
        this.pages = pages;
        this.hasNext = hasNext;
        this.current = page;
        if (!this.hasNext || (rds).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    back() {
      this.$router.push('/home');
    },
    showCate() {
      this.cateShow = true;
      this.getStockCategory();
    },
    getStockCategory() {
      if (this.stockCategory.length > 1) {
        return;
      }
      sendRequest(getStockCategoryOptions).then((res = []) => {
        this.stockCategory = res;
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
      });
    },
  },
  created() {
    this.queryDate = this.queryDateProp;
    this.getStockInfoList();
  },
});
</script>
<style scoped>
  .StockInfoList {
    min-height: 100vh;
  }
  .table-box {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid #2774bd;
    border-bottom: 0;
    overflow: hidden;
    margin-top: 10px;
  }
  .stock-title {
    background-color: #2774bd;
    color: #ffffff;
    padding: 6px 0;
    border-bottom: 1px solid #2774bd;
  }
  .stock-head {
    margin-top: 2px;
    color: #2774bd;
    border-top: 1px solid #2774bd;
    border-bottom: 1px solid #2774bd;
    font-weight: bold;
  }
  .stock-head .stock-border{
    padding: 6px 2px;
  }
  .stock-item {
    color: #0e3a5f;
    border-bottom: 1px solid #2774bd;
  }
  .stock-border {
    border-left: 1px solid #2774bd;
  }
  .stock-item .stock-border {
    padding: 5px 0;
  }
  .stock-border:first-child{
    border-left: 0;
  }
  .stock-phone {
    background-color: #b71831!important;
    border: 1px solid #b71831!important;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    color: #ffffff;
    padding: 3px;
  }
  .fc-red {
    color: #b71831!important;
  }
  .fc-dark {
    color: #0e3a5f;
  }
  .bc-red {
    background-color: #b71831!important;
  }
  .bc-blue {
    background-color: #00bcd4!important;
  }
  .fc-blue {
    color: #00bcd4!important;
  }
  .price-status {
    color: #ffffff;
    border-radius: 4px;
    font-size: 13px;
    text-align: center;
    line-height: 18px;
    width: 19px;
    height: 19px;
  }
  .refresh {
    position: fixed;
    font-size: 12px;
    bottom: 20px;
    right: 5px;
    width: 46px;
    height: 46px;
    /* line-height: 16px; */
    border-radius: 50%;
    box-shadow: 3px 2px 6px rgba(25, 137, 250, 0.5);
    color: #ffffff;
    padding: 6px 0;
    background-color: #1989fa;
  }
  .cate-popup {
    max-height: 400px;
    overflow-y: scroll;
  }
</style>
